import { combineEpics } from 'redux-observable'
import { fetchAdminSpinQueryEpic } from './FetchAdminSpinQueryEpic.js'

export const adminSpinEpics = combineEpics(fetchAdminSpinQueryEpic)
